import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { MostRecentAvatars } from 'components/common/most-recent-avatars/MostRecentAvatars';
import { AvatarData } from 'components/common/most-recent-avatars/MostRecentAvatarTypes';
import SubSection from 'components/common/section/sub-section/SubSection';
import EmptyStateMessageBody from 'components/common/section/sub-section/EmptyStateMessageBody';
import { trackEmptyStartLearningClick } from 'analytics/badgesAnalytics';
import { LEARNING_BADGES_DEFAULT_URL } from 'constants/index';

const MostRecentLearningAchievements = ({
  isPersonalView,
  recentLearningAchievementBadges,
  profileHasConsented,
}: {
  isPersonalView: boolean;
  recentLearningAchievementBadges: AvatarData[];
  profileHasConsented: boolean;
}) => {
  const isRecentLearningAchievementsZero =
    recentLearningAchievementBadges.length === 0 || !profileHasConsented;

  if (!isPersonalView && isRecentLearningAchievementsZero) {
    return null;
  }
  // https://learning.atlassian.com/catalog does not exist yet
  return (
    <div
      data-testid="most-recent-learning-achievements-container"
      css={[
        boxStyles,
        recentLearningAchievementsStyle,
        isRecentLearningAchievementsZero && emptyLearningAchievementsStyles,
      ]}
    >
      <SubSection title={'RECENT LEARNING ACHIEVEMENTS'}>
        {isRecentLearningAchievementsZero ? (
          <EmptyStateMessageBody
            message="Complete a course to earn your first learning badge."
            linkTo={LEARNING_BADGES_DEFAULT_URL}
            linkType="external"
            sendAnalyticsEvent={() =>
              trackEmptyStartLearningClick(isPersonalView)
            }
            linkText="Start learning"
          />
        ) : (
          <MostRecentAvatars data={recentLearningAchievementBadges} />
        )}
      </SubSection>
    </div>
  );
};

const boxStyles = css({
  width: '50%',
  borderRadius: token('border.radius'),
  borderWidth: token('border.width'),
  '@media (max-width: 768px)': {
    width: '100%',
  },
});

const recentLearningAchievementsStyle = css({
  order: 1,
});

const emptyLearningAchievementsStyles = css({
  order: 3,
});

export default MostRecentLearningAchievements;
